if (isBrowser) {
    $(".pixel-perfect").click(function (e) {
        e.stopPropagation();
        $("body").toggleClass('pixel-perfect-active');
    });

    $('.navbar-collapse .nav-item').click(function (e) {
        e.stopPropagation()
        $('.navbar-collapse').collapse('hide')
    })

    window.closeMenu = function () {
        $('.navbar-collapse').collapse('hide')
    }
    window.closeBurger = function () {
        $(".sidebar-opener").click()
    }

    $(function () {
        $(".sidebar-opener").on("click", function (e) {
            $("body").toggleClass("sidebar-active");
            $(".navbar-collapse").removeClass("show");
            e.stopPropagation()
        });
        $("html").click(function (e) {
            if ($(e.target).closest('.sidebar').length == 0)
                $("body").removeClass('sidebar-active');
        });

    });

    $(function () {
        $("body").on("click", '.search-form-opener', function (e) {
            $("body").toggleClass("search-form-active");
            $("#topSearchBar").focus();
            e.stopPropagation()
        });
        $("html").click(function (e) {
            if ($(e.target).closest('.search-form-wrap').length == 0)
                $("body").removeClass('search-form-active');
        });
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 10) {
            $('#header').addClass('header-fixed');
        } else {
            $('#header').removeClass('header-fixed');
        }
    });
}